export const getUniqueSuffix = (name) => {
  const uniqueSuffix = Date.now() + "-" + Math.round(Math.random() * 1e9);
  return uniqueSuffix + "-" + name;
};
